/** Parametr metody, který pomocí callbacku umožní změnit referenci na původní proměnnou */
export class ReferenceParameter<T> {
    private _value: T;
    private _upgradeFn: (newValue: T) => void;

    constructor(value: T, upgradeFn: (newValue: T) => void) {
        this._value = value;
        this._upgradeFn = upgradeFn;
    }

    public get value(): T {
        return this._value;
    }
    public set value(value: T) {
        this._value = value;
        this._upgradeFn(value);
    }
}
